import React from "react";
import { usePublicPageSection } from "../../../../hooks/usePublicPageSection";
import { useLanguage } from "../../../../context/LanguageContext";
import "./Hero.css";

const requireField = (fields, key) => {
  const value = fields?.[key];
  if (value == null || String(value).trim() === "") {
    throw new Error(`News hero field "${key}" is missing from the API response.`);
  }
  return value;
};

const buildModel = (section) => {
  const f = section.fields || {};
  return {
    badge: requireField(f, "badge"),
    title: requireField(f, "title"),
    subtitle: requireField(f, "subtitle"),
    allFilterLabel: requireField(f, "allFilterLabel"),
  };
};

const Hero = ({ activeFilter, onFilterChange, filters = ["All"] }) => {
  const { meta } = useLanguage();
  const { model, error, isLoading } = usePublicPageSection("news", "hero", buildModel);

  if (isLoading) {
    return (
      <section className="news-hero" dir={meta.dir}>
        <div className="news-hero__content">
          <p style={{ color: "#64748b", fontSize: 14 }}>Loading…</p>
        </div>
      </section>
    );
  }

  if (error || !model) {
    return (
      <section className="news-hero" dir={meta.dir}>
        <div className="news-hero__content">
          <p style={{ color: "#b91c1c", fontSize: 14 }}>
            {error || "News hero unavailable."}
          </p>
        </div>
      </section>
    );
  }

  return (
    <section className="news-hero" dir={meta.dir}>
      <div className="news-hero__content">
        <span className="news-hero__badge">{model.badge}</span>
        <h1 className="news-hero__title">{model.title}</h1>
        <p className="news-hero__subtitle">{model.subtitle}</p>

        <div className="news-hero__filters" role="tablist" aria-label="News filters">
          {filters.map((filter) => (
            <button
              key={filter}
              type="button"
              role="tab"
              aria-selected={activeFilter === filter}
              className={`news-hero__filter ${
                activeFilter === filter ? "news-hero__filter--active" : ""
              }`}
              onClick={() => onFilterChange(filter)}
            >
              {filter === "All" ? model.allFilterLabel : filter}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
